import React from 'react'
import { PartnerPart } from '../../api/Common/Types'
import { toVanityUrl } from '../../helpers/StringHelper'
import { Part } from '../../api/Parts/Types'
import { quickAddToCart } from '../../api/Cart/Service'

interface Props {
  readonly part: PartnerPart | Part
  readonly partnerName: string
  readonly part_type?: string
}

class PartnerPartCard extends React.Component<Props> {
  componentDidMount() {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
      container: 'body',
      placement: 'bottom',
    })
  }

  render() {
    const {
      partnerName,
      part: { id },
    } = this.props

    const name =
      this.props.part.part_type === 'Part'
        ? this.props.part.name
        : this.props.part.imported_part.name
    const image_path =
      this.props.part.part_type === 'Part'
        ? this.props.part.image_path
        : this.props.part.imported_part_version.image_path
    const part_location =
      this.props.part.part_type === 'Part'
        ? `/parts/${this.props.part.url}-${id}`
        : `/partners/parts/${id}/${toVanityUrl(name)}`

    return (
      <div className='part-card'>
        <div className='part-card-img'>
          <img alt={`Part ${id} - ${name} | Vention`} src={image_path} title={name} />
          <div className='part-card-overlay'>
            <div className='grid'>
              <a className='button button-block button-white-outline' href={part_location}>
                View Part
              </a>
              {(this.props.part.part_type === 'Part' || !!this.props.part.supplier_price_usd) && (
                <a
                  onClick={event => quickAddToCart(event, `/partner_parts/${id}/buy`, 'Part')}
                  className='button button-block button-white-outline'
                >
                  Add to Cart
                </a>
              )}
            </div>
          </div>
        </div>

        <div className='part-card-body'>
          <a
            className='part-card-name'
            href={part_location}
            data-toggle='popover'
            data-content={name}
          >
            {name}
          </a>
          <div className='part-card-supplier'>{partnerName}</div>
        </div>
      </div>
    )
  }
}

export default PartnerPartCard
